var _path, _circle, _circle2, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapMarker5Post(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 49,
    viewBox: "0 0 39 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.094 0C8.565 0 0 8.565 0 19.094c0 7.514 4.342 14.815 9.139 20.551 4.444 5.313 8.829 8.766 9.013 8.91a1.52 1.52 0 0 0 1.883 0c.185-.144 4.57-3.597 9.014-8.91 4.798-5.737 9.139-13.038 9.139-20.551C38.188 8.565 29.622 0 19.094 0Z",
    fill: "#39B54A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.094,
    cy: 19.094,
    r: 14.5,
    fill: "#FFFFFF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.094,
    cy: 19.094,
    r: 11.5,
    fill: "#E31E24"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 19.094,
    y: 26,
    textAnchor: "middle",
    fontFamily: "Arial, sans-serif",
    fontSize: 21,
    fontWeight: 700,
    fill: "#FFFFFF"
  }, "5")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarker5Post);
export default __webpack_public_path__ + "static/media/map-marker-5post.c9c6616610789c1ac553f4c5b7903139.svg";
export { ForwardRef as ReactComponent };